import React from "react"
import PropTypes from "prop-types"
import { getMessage } from "@/utils/MessageUtils"

class OriginalSourceInfo extends React.Component {
  static propTypes = {
    sourceType: PropTypes.string,
  }

  render() {
    const { sourceType } = this.props
    const sourceTypeLevel1 = getMessage(sourceType, "OriginalSourceType")
    const sourceTypeLevel2 = getMessage(sourceType, "SystemSourceType")
    return (
      <span className="OriginalSourceInfo">
        {sourceTypeLevel1} - {sourceTypeLevel2}
      </span>
    )
  }
}

export default OriginalSourceInfo
